export default __webpack_public_path__ + "static/media/chevron-right.cd2fb34e.svg";